import { AxiosInstance } from 'axios'

import { apiPaths } from '@percent/partner-dashboard/services/apiPaths'
import { GamificationPartnerConfigResponse, RewardRulesConfigurationResponse } from './gamificationService.types'

type GamificationServiceCapabilities = {
  percentClient: AxiosInstance
}

export const gamificationService = ({ percentClient }: GamificationServiceCapabilities) => ({
  getGamificationConfig: () =>
    percentClient.get<GamificationPartnerConfigResponse>(`${apiPaths.v1Partner}gamification/config`),
  getRewardRulesConfiguration: () =>
    percentClient.get<RewardRulesConfigurationResponse>(`${apiPaths.v1Partner}gamification/reward-rules-configuration`)
})
